import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
render(<HelmetProvider data-id="element-225">
    <App data-id="element-226" />
  </HelmetProvider>, document.getElementById('root'));